import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
  selector: 'korviu-no-data',
  standalone: true,
  imports: [NzIconModule, TranslateModule],
  templateUrl: './korviu-no-data.component.html',
  styleUrls: ['./korviu-no-data.component.scss']
})
export class KorviuNoDataComponent {
  @Input() message: string = null;
  @Input() size: string = null;

  constructor() {}
}
